import * as angular from 'angular';

import { ComponentDefinition, TagDefinition, ObjectType } from '../../models/';
import { IInputValuesService, ICalculatedValuesService } from '../../services/';
import { tagSelected, refreshClick } from '../../common/';

class StatisticsController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;
    tagDefinitionGuid: string;
    average: number;
    standardDeviation: number;
    gradient: number;
    objectType: any;
    available: boolean;
    bound: boolean;
    data: { average?: number; standardDeviation?: number, gradient?: number };

    private _garbages: (() => void)[] = [];

    static $inject = ['$scope', 'inputValuesService', 'calculatedValuesService'];

    constructor(
        private _$scope: angular.IScope,
        private _inputValuesService: IInputValuesService,
        private _calculatedValuesService: ICalculatedValuesService) {
    }

    $onInit() {
        this.available = false;
        if (!this.bound) {
            this._garbages.push(this._$scope.$on(tagSelected, (event, data) => {
                const tag: TagDefinition = data;
                if (tag) {
                    this.tagDefinitionGuid = tag.guid;
                    this.objectType = ObjectType.Tag;
                    this.readData();
                }
            }));

            this._garbages.push(this._$scope.$on(refreshClick, (event, data) => {
                this.readData(!!data.force);
            }));
        } else {
            this.setBoundData();
        }
    }

    $onDestroy() {
        this._garbages.forEach(g => g());
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['data']) {
            const data = changesObj['data'].currentValue;
            if (data) {
                this.data = data;
                this.setBoundData();
            }
        }

        if (changesObj['tagDefinitionGuid']) {
            const tagDefinitionGuid = changesObj['tagDefinitionGuid'].currentValue;
            this.tagDefinitionGuid = tagDefinitionGuid;
            this.refreshData();
        }

        if (changesObj['objectType']) {
            const objectType = changesObj['objectType'].currentValue;
            this.objectType = objectType;
            this.refreshData();
        }
    }

    private setBoundData() {
        if (this.data) {
            this.average = this.data.average;
            this.standardDeviation = this.data.standardDeviation;
            this.gradient = this.data.gradient;
            this.setAvailability();
        }
    }

    private refreshData() {
        if (this.tagDefinitionGuid && !this.bound) {
            this.readData();
        }
    }

    private readData(force: boolean = false) {
        if (this.tagDefinitionGuid) {
            this.isLoading = true;

            const promise = this.objectType
                ? this._calculatedValuesService.getIdentifierStatistics(this.tagDefinitionGuid, force)
                : this._inputValuesService.getStatistics(this.tagDefinitionGuid, force);

            (promise as any)
                .then((data) => {
                    if (data) {
                        this.average = data.average;
                        this.standardDeviation = data.stdDev;
                        this.gradient = data.slope;
                        this.setAvailability();
                    }
                })
                .finally(() => this.isLoading = false);
        }
    }

    private setAvailability() {
        this.available = this.average !== undefined &&
            this.standardDeviation !== undefined &&
            this.gradient !== undefined;
    }
}

export const wtStatistics: ComponentDefinition = {
    componentId: 'wtStatistics',
    controller: StatisticsController,
    template: require('./statistics.component.html'),
    controllerAs: 'vm',
    bindings: {
        tagDefinitionGuid: '<?',
        objectType: '<?',
        tagDefinition: '<?',
        bound: '<?',
        data: '<?'
    }
};
